export const showSuccessNotification = (comp, message) => {
  comp.$vs.notify({
    title: 'Success',
    text: message,
    color: '#00C48C',
    icon: 'check_box',
    position: 'top-right',
    time:5000
  })
}

export const showFailedNotification = (comp, message, title) => {
  comp.$vs.notify({
    title: title || 'Failed',
    text: message || 'Something went wrong',
    color: 'danger',
    icon: 'close',
    position: 'top-right',
    time:5000
  })
}

export const showWarningNotification = (comp, message) => {
  comp.$vs.notify({
    title: 'Something Wrong',
    text: message || 'Something went wrong',
    color: 'warning',
    icon: 'priority_high',
    position: 'top-right',
    time:5000
  })
}

export const showPageLoading = (comp) => comp.$vs.loading({ type: 'radius', color: 'secondary', text: 'Please Wait' })

export const closePageLoading = (comp) => comp.$vs.loading.close()
